import React from 'react'
import PropTypes from 'propTypes'
import styles from './styles'

const DropdownHeader = ({ text }) => (
  <li role="menuitem" className={styles.wrapper}>
    {text}
  </li>
)

DropdownHeader.propTypes = {
  text: PropTypes.string,
}

export default DropdownHeader
